<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="2" lg="3" md="3" sm="6">
        <v-autocomplete v-model="queryForm.section" :items="sections" label="标段"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable hide-details>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="3" sm="6">
        <v-autocomplete v-model="queryForm.name" :items="linenames" label="线路名称"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable hide-details>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="6" sm="6">
        <a-space>
          <v-autocomplete v-model="queryForm.departure" :items="departures" label="始发"
            :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable hide-details>
          </v-autocomplete>→
          <v-autocomplete v-model="queryForm.destination" :items="destinations" label="到达"
            :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable hide-details>
          </v-autocomplete>
        </a-space>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="3" sm="6">
        <v-autocomplete v-model="queryForm.transport_kind" :items="transport_kinds" label="单边/往返"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable hide-details>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="3" sm="6">
        <v-btn @click="getdata()" color="primary" tile>查询</v-btn>
      </v-col>
    </v-row>
    <div class="d-flex justify-space-between mt-2">
      <v-btn color="primary" tile @click="getdata()">
        <v-icon small>mdi-refresh</v-icon> 刷新
      </v-btn>
      <a-space>
        <v-btn color="success" tile @click="showadd">
          <v-icon small>mdi-plus</v-icon> 新增市场数据
        </v-btn>
        <v-btn color="cyan" tile dark @click="importfile">
          <v-icon small>mdi-upload</v-icon> 导入市场数据
        </v-btn>
      </a-space>
    </div>
    <v-card tile class="mt-2">
      <a-table size="small" :columns="headers" :data-source="list" :pagination="false" :locale="{ emptyText: '暂无数据' }"
        :scroll="{ x: width, y: height }" row-key="_id">
        <template slot="title">
          <div class="d-flex align-center pl-2">
            <span>共 {{ length }} 页 / {{ count }} 条数据</span>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
                  {{ limit }}/页
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in pages" @click="limit = item.value" :key="index">
                  <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template slot="index" slot-scope="text, record, index">
          <span v-if="record._id">{{ index }}</span>
        </template>
        <!--标段-->
        <template slot="section" slot-scope="text, record">
          <template v-for="item in sections">
            <span v-if="record.section === item.value" :key="item.value" :style="{
              'color': $utils.textToBgColor(item.text.replace('标段', ''))
            }">{{ item.text }}</span>
          </template>
        </template>
        <template slot="T_income_price_12">
          <p>收入12</p>
          <p>(元/车)</p>
        </template>
        <template slot="T_income_price">
          <p>收入30</p>
          <p>(元/车)</p>
        </template>
        <template slot="year_income" slot-scope="text, record">
          <span class="success--text">{{ record.fyear_income }}</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space v-if="record._id">
            <v-btn text tile color="success" @click="showedit(record)"> 编辑 </v-btn>
            <a-popconfirm title="确认删除数据?" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)" placement="left">
              <v-btn text tile color="error"> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <v-dialog v-model="model" persistent max-width="750px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ modeltitle }}
            <v-icon @click="cancelsave">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-select v-model="form.section" :items="sections" :rules="[vrules.required]" no-data-text="无" dense
                    outlined :menu-props="{ bottom: true, offsetY: true }" @change="changeSection">
                    <template v-slot:label>
                      标段 <span class="red--text">*</span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-select v-model="form.postlineid" :items="fpostlines" :rules="[vrules.required]" no-data-text="无"
                    dense outlined :menu-props="{ bottom: true, offsetY: true }" @change="changePostLine">
                    <template v-slot:label>
                      线路 <span class="red--text">*</span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.income_price_12" :rules="[vrules.required]" type="number" suffix="元"
                    outlined dense>
                    <template v-slot:label>
                      收入12(元/车) <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.income_price" :rules="[vrules.required]" type="number" suffix="元" outlined
                    dense>
                    <template v-slot:label>
                      收入30(元/车) <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.year_shift_order_12" :rules="[vrules.required]" type="number" outlined
                    dense>
                    <template v-slot:label>
                      预计班次12(年) <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.year_shift_order" :rules="[vrules.required]" type="number" outlined dense>
                    <template v-slot:label>
                      预计班次30(年) <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="form.km" :rules="[vrules.required]" type="number" outlined dense>
                    <template v-slot:label>
                      里程<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="form.remark" outlined rows="2" dense>
                    <template v-slot:label>
                      备注
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!valid" @click="save">确定</v-btn>
            <v-btn tile @click="cancelsave">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="importmodal" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable
      max-width="1000px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon tile @click="importmodal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>导入市场数据</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn tile text @click="importmodal = false"> 关闭 </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <div class="d-flex justify-space-between align-center mb-2">
              <a-space>
                <v-btn color="primary" tile @click="$refs.fileref.click()">选择文件</v-btn>
                <v-btn color="success" tile :disabled="importdata.length === 0" @click="saveimport">提交数据</v-btn>
              </a-space>
              <v-btn color="primary" tile outlined @click="downloadtemplate">
                <v-icon>mdi-download</v-icon>{{ templateFile.name }}
              </v-btn>
            </div>
            <a-table size="small" :columns="iheaders" :data-source="importdata" :pagination="false"
              :locale="{ emptyText: '暂无数据' }" :scroll="{ y: height }">
              <template slot="index" slot-scope="text, record, index">
                {{ index + 1 }}
              </template>
            </a-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <input type="file" accept=".xlsx" ref="fileref" @change="change" style="display: none;" />
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
import ExcelJS from 'exceljs';
export default {
  name: "MarketData",
  data() {
    return {
      queryForm: {
        section: "",
        name: "",
        departure: "",
        destination: "",
        transport_kind: "",
      },
      linenames: [],
      pages: [
        { text: "20/页", value: 20 },
        { text: "50/页", value: 50 },
        { text: "100/页", value: 100 },
        { text: "200/页", value: 200 },
        { text: "500/页", value: 500 },
        { text: "1000/页", value: 1000 },
      ],
      headers: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "省份", dataIndex: "province", scopedSlots: { customRender: "province" }, width: 100, align: "center" },
        { title: "标段", dataIndex: "section", scopedSlots: { customRender: "section" }, width: 100, align: "center" },
        { title: "线路名称", dataIndex: "linename", scopedSlots: { customRender: "linename" }, width: 100, align: "center" },
        { title: "邮路级别", dataIndex: "postroutelevel", scopedSlots: { customRender: "postroutelevel" }, width: 100, align: "center" },//一干、二干
        { title: "单边/往返", dataIndex: "transport_kind", scopedSlots: { customRender: "transport_kind" }, width: 100, align: "center" },
        { title: "里程(KM)", dataIndex: "km", scopedSlots: { customRender: "km" }, width: 100, align: "center" },
        { dataIndex: "income_price_12", slots: { title: "T_income_price_12" }, scopedSlots: { customRender: "income_price_12" }, width: 120, align: "center" },
        { dataIndex: "income_price", slots: { title: "T_income_price" }, scopedSlots: { customRender: "income_price" }, width: 120, align: "center" },
        { title: "预计班次12(年)", dataIndex: "year_shift_order_12", scopedSlots: { customRender: "year_shift_order_12" }, width: 100, align: "center" },
        { title: "预计班次30(年)", dataIndex: "year_shift_order", scopedSlots: { customRender: "year_shift_order" }, width: 100, align: "center" },
        { title: "年度总收入(元)", dataIndex: "year_income", scopedSlots: { customRender: "year_income" }, width: 140, align: "center" },
        { title: "备注", dataIndex: "remark", scopedSlots: { customRender: "remark" }, width: 100 },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 150, align: "center" },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      valid: true,
      model: false,
      modeltitle: "",
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      form: {},
      sections: [],
      postlines: [],
      postlinecontracts: [],
      postroutelevels: [
        { label: "一干", text: "一干", value: "一级干线" },
        { label: "二干", text: "二干", value: "二级干线" },
      ],
      transport_kinds: [
        { label: "单边", text: "单边", value: "单程" },
        { label: "往返", text: "往返", value: "往返" },
      ],
      importmodal: false,
      iheaders: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "省份", dataIndex: "province", scopedSlots: { customRender: "province" }, width: 100, align: "center" },
        { title: "线路名称", dataIndex: "linename", scopedSlots: { customRender: "linename" }, width: 120, align: "center" },
        { title: "邮路级别", dataIndex: "postroutelevel", scopedSlots: { customRender: "postroutelevel" }, width: 100, align: "center" },//一干、二干
        { title: "单边/往返", dataIndex: "transport_kind", scopedSlots: { customRender: "transport_kind" }, width: 120, align: "center" },
        { title: "里程(KM)", dataIndex: "km", scopedSlots: { customRender: "km" }, width: 100, align: "center" },
        { title: "收入12(元/车)", dataIndex: "income_price_12", scopedSlots: { customRender: "income_price_12" }, width: 120, align: "center" },
        { title: "收入30(元/车)", dataIndex: "income_price", scopedSlots: { customRender: "income_price" }, width: 120, align: "center" },
        { title: "预计班次12(年)", dataIndex: "year_shift_order_12", scopedSlots: { customRender: "year_shift_order_12" }, width: 120, align: "center" },
        { title: "预计班次30(年)", dataIndex: "year_shift_order", scopedSlots: { customRender: "year_shift_order" }, width: 120, align: "center" },
      ],
      importFile: null,
      importdata: [],
      templateFile: {
        url: `${process.env.BASE_URL}template/市场数据导入模板.xlsx`,
        name: '市场数据导入模板.xlsx',
      },
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    departures() {
      return _.uniq(this.linenames.reduce((a, b) => a.concat([b.value.split('-')[0]]), [])).map(n => ({ value: n, text: n, label: n }));
    },
    destinations() {
      return _.uniq(this.linenames.reduce((a, b) => a.concat([b.value.split('-')[1]]), [])).map(n => ({ value: n, text: n, label: n }));
    },
    fpostlines() {
      if (this.form.section) {
        return this.postlines.filter(n => n.section === this.form.section);
      }
      return [];
    },
  },
  components: {},
  watch: {
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  mounted() {
    this.height = window.innerHeight - 350;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 350;
    };
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
  },
  activated() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/marketdata/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          let total_year_shift_order_12 = 0;
          let total_year_shift_order = 0;
          let total_year_income = this.$d();
          this.list = res.data.list.map(n => {
            total_year_shift_order_12 += (Number(n.year_shift_order_12) || 0);
            total_year_shift_order += (Number(n.year_shift_order) || 0);
            total_year_income = total_year_income.plus(n.year_income);
            return {
              ...n,
              fyear_income: this.$utils.formatMoney(n.year_income, 2, ''),
            }
          });
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
          this.linenames = res.data.linenames.map(n => ({ value: n, text: n, label: n }));
          this.sections = res.data.sections;
          this.list.unshift({
            _id: "",
            year_shift_order_12: total_year_shift_order_12,
            year_shift_order: total_year_shift_order,
            year_income: total_year_income.toString(),
            fyear_income: this.$utils.formatMoney(total_year_income.toString(), 2, ''),
          });
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    initform() {
      return {
        _id: "",
        province: "河南",
        linename: "",
        postroutelevel: "二级干线",
        transport_kind: "单程",
        income_price_12: "",
        income_price: "",
        year_shift_order_12: "",
        year_shift_order: "",
        km: "",
        remark: "",
      };
    },
    showadd() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/marketdata/info", { _id: "" }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.postlines = res.data.postlines;
          this.postlinecontracts = res.data.postlinecontracts;
          this.form = res.data.dataForm;
          this.modeltitle = "新增市场数据";
          this.model = true;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showedit(item) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/marketdata/info", { _id: item._id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.postlines = res.data.postlines;
          this.postlinecontracts = res.data.postlinecontracts;
          this.form = res.data.dataForm;
          this.modeltitle = "编辑市场数据";
          this.model = true;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/marketdata/save", { dataForm: this.form }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.model = false;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsave() {
      this.$refs.form.resetValidation();
      this.model = false;
    },
    changeSection(v) {
      console.log('changeSection', v);
      this.form.postlineid = "";
      this.form.income_price_12 = "";
      this.form.income_price = "";
      this.form.km = "";
    },
    changePostLine(v) {
      console.log('changePostLine', v);
      let postlinecontract12 = this.postlinecontracts.find(n => n.postlineid === v && n.vehicle_type === '12吨');
      let postlinecontract30 = this.postlinecontracts.find(n => n.postlineid === v && n.vehicle_type === '30吨');
      if (postlinecontract12) {
        this.form.income_price_12 = postlinecontract12.price;
        this.form.km = postlinecontract12.km;
      }
      if (postlinecontract30) {
        this.form.income_price_30 = postlinecontract30.price;
        this.form.km = postlinecontract12.km;
      }
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/marketdata/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    ///导入市场数据
    importfile() {
      this.importmodal = true;
    },
    downloadtemplate() {
      this.$download(this.templateFile.url, this.templateFile.name);
    },
    change(e) {
      let file = e.target.files[0];
      if (!file) return;
      this.importFile = file;
      this.$refs.fileref.value = null;
      this.readExcel();
    },
    async readExcel() {
      try {
        const workbook = new ExcelJS.Workbook()
        await workbook.xlsx.load(this.importFile);
        const worksheet = workbook.worksheets[0]
        const rowCount = worksheet.rowCount;
        const rows = [];
        const headerRow = worksheet.getRow(1);
        for (let i = 2; i <= rowCount; i++) {
          const row = worksheet.getRow(i);
          const cellCount = row.cellCount;
          let item = {
            province: "河南",
            linename: "",
            postroutelevel: "二级干线",
            transport_kind: "单程",
            income_price_12: "",
            income_price: "",
            year_shift_order_12: "",
            year_shift_order: "",
            km: "",
          };
          for (let j = 1; j <= cellCount; j++) {
            let header = headerRow.getCell(j).text;
            let key = "";
            if (header === '省份') key = 'province';
            if (header === '线路名称') key = 'linename';
            if (header === '邮路级别') key = 'postroutelevel';
            if (header === '单边/往返') key = 'transport_kind';
            if (header === '收入12(元/车)') key = 'income_price_12';
            if (header === '收入30(元/车)') key = 'income_price';
            if (header === '预计班次12(年)') key = 'year_shift_order_12';
            if (header === '预计班次30(年)') key = 'year_shift_order';
            if (header === '里程(KM)') key = 'km';
            const cell = row.getCell(j);
            if (cell.type == 0 || cell.type == 8) {
              item[key] = cell.text;
            }
            else if (cell.type == 2 || cell.type == 3) {
              item[key] = cell.value;
            }
            else if (cell.type == 4) {
              item[key] = this.$utils.dateFormat(cell.value, "YYYY-MM-DD HH:mm:ss");
            }
            else if (cell.type == 6) {
              item[key] = cell.value.result;
            }
            else {
              console.log(cell.type, key);
              item[key] = cell.value;
            }
            if (
              key === "income_price"
              || key === "income_price_12"
            ) {
              item[key] = this.$d(this.$d(item[key]).toFixed(2)).toString();
            }
            // if (!item[key]) {
            //   throw new Error(`${header}数据无效`);
            // }
          }
          rows.push(item);
        }
        this.importdata = rows;
        console.log('读取成功：', rows)
      } catch (err) {
        console.error('读取失败：', err)
        this.$alert(err.message);
      }
    },
    saveimport() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/marketdata/saveimport", { importdata: this.importdata }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.importmodal = false;
          this.importdata = [];
          this.importFile = null;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>